(function($){
$(document).ready(function() {

    if ( $('.popinmessage').html() != undefined && $('.popinmessage').html().trim() != '' ) {
        $.popin.alert( {
            type: $('.popinmessage').data('type'),
            title: $('.popinmessage').data('title'),
            message: $('.popinmessage').html(),
            button: $('.popinmessage').data('button')
        });
    }

    // $('.slider-infos').slick({
    //     autoplay: false,
    //     arrows: true,
    //     dots: false,
    //     infinite: false,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     speed: 500,
    //     fade: true,
    //     cssEase: 'ease-out',
    //     responsive: [
    //       {
    //         breakpoint: 1240,
    //         settings: {
    //           arrows: false,
    //           dots: true,
    //         }
    //       }
    //     ]
    // });

})
})(jQuery);
